import { render, staticRenderFns } from "./g-help.vue?vue&type=template&id=d1c2f228"
import script from "./g-help.vue?vue&type=script&lang=js"
export * from "./g-help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports